angular.module('tasks')
    .component('taskNoModeratorAssignedIco', {
        bindings: {
            moderator: '<'
        },
        template: `
            <span ng-if="$ctrl.moderator == null" class="document-info-header" title="Nie przypisano opiekuna do zadania">
                <i class="fa fa-fw fa-user text-danger"></i>
            </span>
        `
    })
